<template>
  <div id="particles-js">
    <v-app id="loginForm" color="transparent">
      <v-row no-gutters justify="center" align="center">
        <!--        <div class="giris-firma-block text-right">-->
        <!--          <span class="title">Korhan</span>-->
        <!--          <br />-->
        <!--          <span class="subtitle">Software</span>-->
        <!--        </div>-->
        <v-col cols="12" lg="3" md="10" sm="10">
          <v-card class="mx-auto" :elevation="10" rounded="lg" max-width="350">
            <div class="login-form">
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-icon>cards-diamond</v-icon>
                <h1 class="title text-center my-2 mb-4">
                  {{ $t("PANEL.LOGIN.LOGIN_WELCOME") }}
                </h1>
                <!-- <h2 class="text-caption text-center mb-4">Sisteme giriş yapmak için kullanıcı adı ve şifrenizi giriniz.</h2> -->
                <v-text-field solo prepend-inner-icon="mdi-account" v-model="user" :rules="nameRules" :label="$t('PANEL.LOGIN.LOGIN_USER')" required></v-text-field>
                <v-text-field
                  solo
                  prepend-inner-icon="mdi-lock"
                  class="input-group--focused"
                  :hint="$t('PANEL.LOGIN.LOGIN_RULE_PASS2')"
                  :type="sifreGoster ? 'text' : 'password'"
                  v-model="password"
                  :rules="passwordRules"
                  :append-icon="sifreGoster ? 'mdi-eye' : 'mdi-eye-off'"
                  :label="$t('PANEL.LOGIN.LOGIN_PASS')"
                  @click:append="sifreGoster = !sifreGoster"
                  @keyup.enter="girisYap"
                  required
                ></v-text-field>
                <v-checkbox class="mt-0" color="green" v-model="session" :label="$t('PANEL.LOGIN.LOGIN_REMEMBER')"></v-checkbox>
                <div class="my-2"></div>
                <div class="d-flex justify-end">
                  <v-btn :disabled="!valid" color="success" @click="girisYap" :loading="loadingStatus">
                    <v-icon size="20" class="mr-1">mdi-login-variant</v-icon>
                    {{ $t("PANEL.LOGIN.LOGIN_BUTTON") }}
                  </v-btn>
                </div>
                <div class="my-2"></div>
              </v-form>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-app>
  </div>
</template>

<script>
// import axios from "axios"
import "particles.js";
import { mapState } from "vuex";
import axios from "axios";
import store from "@/store";

const particlesJS = window.particlesJS;

export default {
  name: "LoginForm",
  data() {
    return {
      valid: true,
      user: "",
      nameRules: [
        v => !!v || this.$t("PANEL.LOGIN.LOGIN_RULE_USER1")
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      password: "",
      passwordRules: [v => !!v || this.$t("PANEL.LOGIN.LOGIN_RULE_PASS1"), v => v.length >= 8 || this.$t("PANEL.LOGIN.LOGIN_RULE_PASS3")],
      session: false,
      sifreGoster: false,
      loginMessage: false,
      loginSuccess: false,
      loadingStatus: false
    };
  },

  computed: {
    ...mapState({
      apiLanguage: state => state.Language.apiLanguage
    })
  },

  methods: {
    girisYap() {
      const { user, password, session } = this;
      this.loadingStatus = true;
      this.$store
        .dispatch("User/UserLogin/authRequest", { user, password, session })
        .then(res => {
          if (res.status === 200) {
            this.loginSuccess = true;
            // this.$snotify.success(this.LANG.LOGIN_NOTIFY_TEXT_SUCCESS, this.LANG.LOGIN_NOTIFY_TITLE_SUCCESS);

            /**
             * Languages Process
             */
            let langProcess = [];
            langProcess.push(this.$store.dispatch("Language/setApiLang"));
            langProcess.push(this.$store.dispatch("Language/setLangsDetails"));

            Promise.all(langProcess)
              .then(() => {
                /**
                 * Get The System Tree
                 */
                // return this.$store.dispatch("Widget/WidgetLists/systemTree").then(({ data }) => {
                //   return localStorage.setItem("system_tree", JSON.stringify(data.system_tree));
                // });
                return axios({
                  url: this.$ApiUrl,
                  method: "POST",
                  data: {
                    data: {
                      methodName: "Api/Widget/SystemTree"
                    }
                  },
                  headers: {
                    Authorization: `Bearer ${res.data.token}`
                  }
                }).then(({ data: { data: { system_tree } } }) => {
                    return localStorage.setItem("system_tree", JSON.stringify(system_tree));
                });
              })
              .then(() => {
                if (!!localStorage.getItem("system_tree")) {
                  const lastRoute = localStorage.getItem("last-route");
                  this.$router.go(lastRoute || "/");
                }

                this.loadingStatus = false;
              });
          } else {
            this.loginMessage = res.data.errMessage;
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .finally(() => {
          this.loadingStatus = false;
        });
    }
  },
  mounted() {
    particlesJS.load("particles-js", "./assets/js/particles.json", function() {
      console.log("callback - particles-js config loaded");
    });
  }
};
</script>

<style>
#loginForm {
  background: transparent;
  position: relative;
  z-index: 2;
}

.login-form {
  background: #fff;
  padding: 15px 25px;
  pointer-events: all;
}

canvas {
  position: absolute;
  top: 0;
  display: block;
  /* vertical-align: bottom; */
  z-index: 1;
}

/* ---- particles.js container ---- */

#particles-js {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #dddddd;
  /* background-image: url(""); */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
}

#particles-js > div {
  pointer-events: none;
}

/* ---- stats.js ---- */

.count-particles {
  background: #000022;
  position: absolute;
  top: 48px;
  left: 0;
  width: 80px;
  color: #13e8e9;
  font-size: 0.8em;
  text-align: left;
  text-indent: 4px;
  line-height: 14px;
  padding-bottom: 2px;
  font-family: Helvetica, Arial, sans-serif;
  font-weight: bold;
}

.js-count-particles {
  font-size: 1.1em;
}

#stats,
.count-particles {
  -webkit-user-select: none;
}

#stats {
  border-radius: 3px 3px 0 0;
  overflow: hidden;
}

.count-particles {
  border-radius: 0 0 3px 3px;
}

.giris-firma-block {
  position: absolute;
  top: 15%;
  right: 5%;
  font-weight: bolder;
  color: #0000001f;
}

.giris-firma-block span.title {
  font-size: 60px !important;
  color: #00bfbf66;
}

.giris-firma-block span.subtitle {
  font-size: 25px !important;
  color: #00bfbf66;
}
</style>